module.exports = __webpack_public_path__ + "img/01_1.f715baef.png";